var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectionEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.46383 1.19827C8.90518 0.63964 7.99946 0.639638 7.44081 1.19827L0.690172 7.94894C0.490479 8.14863 0.35436 8.40297 0.298977 8.67986L0.0190493 10.0795C-0.114408 10.7468 0.473914 11.3351 1.1412 11.2017L2.54083 10.9217C2.81776 10.8664 3.07209 10.7302 3.27179 10.5306L10.0224 3.77989C10.5811 3.22126 10.5811 2.31554 10.0224 1.7569L9.46383 1.19827ZM8.11513 1.8726C8.30138 1.68639 8.60326 1.68639 8.7895 1.8726L9.3481 2.43123C9.53435 2.61744 9.53435 2.91935 9.3481 3.10556L8.07422 4.37943L6.8413 3.14647L8.11513 1.8726ZM6.16693 3.8208L1.3645 8.62326C1.29793 8.68983 1.25256 8.77461 1.2341 8.86692L0.954174 10.2665L2.35381 9.98659C2.44612 9.96814 2.5309 9.92279 2.59746 9.85623L7.3999 5.05376L6.16693 3.8208Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionEdit);
export default __webpack_public_path__ + "static/media/sectionEdit.a412c8fd38c19c6a6d7b1df581a95f56.svg";
export { ForwardRef as ReactComponent };